import { render, staticRenderFns } from "./approve-detail.vue?vue&type=template&id=9707427a&scoped=true"
import script from "./approve-detail.vue?vue&type=script&lang=js"
export * from "./approve-detail.vue?vue&type=script&lang=js"
import style0 from "./approve-detail.vue?vue&type=style&index=0&id=9707427a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9707427a",
  null
  
)

export default component.exports